import { render, staticRenderFns } from "./edutalk-quick-menu.vue?vue&type=template&id=0071b5d2"
import script from "./edutalk-quick-menu.vue?vue&type=script&lang=js"
export * from "./edutalk-quick-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports